import { type SelectItem } from './types'

const shoeSizes: string[] = [
  '5',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '9.5',
  '10',
  '10.5',
  '11',
  '11.5',
  '12',
  '12.5',
  '13',
  '13.5',
  '14',
  '14.5',
  '15',
]

export const SHOE_SIZES: SelectItem[] = shoeSizes.map((item) => ({
  label: `${item}`,
  value: item,
}))
